module.exports = __webpack_public_path__ + "img/Gallery_3_07.c079f71c.jpeg";